// extracted by mini-css-extract-plugin
export var contentWrapper = "Post-module--content-wrapper--tKYn0";
export var post = "Post-module--post--rhz5a";